import React from 'react';
import DropdownMenu from './DropdownMenu';

export default function RowActionsMenu({ items = [], ariaLabel = 'Row actions' }) {
  return (
    <DropdownMenu
      placement="top"
      autoFlip
      usePortal
      trigger={(
        <button
          type="button"
          aria-label={ariaLabel}
          className="h-7 w-7 rounded border border-gray-600 text-gray-300 hover:text-white hover:border-gray-500"
        >
          ...
        </button>
      )}
      items={items}
    />
  );
}
